import pluralize from "pluralize";
import React, { FC, useContext, useEffect, useState } from "react";

import { css } from "@emotion/react";
import { DiscountTierDto } from "@intelligems/ig-types";
import { getTextColor } from "@intelligems/ig-utils";

import { DiscountProgressBarContext } from "../context";
import { buildBuyMoreRewardSnippet } from "../progress-bar";

interface TooltipProps {
  tier: DiscountTierDto;
}

export const Tooltip: FC<TooltipProps> = ({ tier }) => {
  const { theme, windowState, getWidgetConfig, currencyFormatter } = useContext(
    DiscountProgressBarContext
  );
  const [text, setText] = useState<string>("");

  const rightAlign =
    windowState.discount.tiers.length === 2 &&
    tier.id === windowState.discount.tiers[1].id;

  const containerClass = css`
    background-color: ${theme.tooltip.backgroundColor};
    border-radius: 12px;
    color: black;
    min-width: 65px;
    min-height: 40px;
    position: relative;
    right: ${rightAlign ? "43px" : undefined};
  `;

  const arrowClass = css`
    position: absolute;
    height: 14px;
  `;

  const startArrowClass = css`
    ${arrowClass};
    left: 15%;
    transform: translate(-15%, -12px);
  `;

  const centerArrowClass = css`
    ${arrowClass};
    left: 50%;
    transform: translate(-50%, -12px);
  `;

  const endArrowClass = css`
    ${arrowClass};
    left: 94%;
    transform: translate(-85%, -12px);
  `;
  const messageClass = css`
    color: ${getTextColor(
      getComputedStyle(document.documentElement).getPropertyValue(
        theme.tooltip.backgroundColorKey
      )
    )};
    display: flex;
    align-items: center;
    text-align: center;
    margin: 10px;
    height: calc(100% - 20px);
    line-height: normal;
  `;

  useEffect(() => {
    const fetchTooltip = async () => {
      const textReplacements = getWidgetConfig(
        // @ts-ignore
        "variables.textReplacements"
      );
      let text = "";
      await windowState.widget
        .getTooltipMessage(windowState.discount, tier.id, textReplacements)
        .then((tooltipResp) => (text = tooltipResp));

      text = text
        .replaceAll(
          "#unitName",
          pluralize(
            getWidgetConfig(
              "variables.textReplacements.unitName"
            ) as unknown as string,
            tier.minimumUnits
          )
        )
        .replaceAll(
          "#unit",
          `${currencyFormatter(
            tier.minimumUnits,
            windowState.discount.unitType
          )}`
        );

      const snippetOptions = await windowState.widget.getWhatsUnlocked([tier]);

      text = text.replaceAll(
        "#rewardSnippet",
        buildBuyMoreRewardSnippet(snippetOptions)
      );

      let tiersUnlockedText: string = "";
      await windowState.widget
        .standardTiersUnlockedReplacements(text, {
          discount: windowState.discount,
          unitDiscount: tier.unitDiscount,
          textReplacements: {},
        })
        .then((resp) => {
          tiersUnlockedText = resp;
        });
      setText(tiersUnlockedText);
    };
    void fetchTooltip();
  }, [windowState.discount]);
  return (
    <div className={"ig-dp-tooltip-container"} css={containerClass}>
      <span css={rightAlign ? endArrowClass : centerArrowClass}>
        <svg width={27} height={14} fill="white">
          <path
            d="M13.09 0 0 13.09h26.182L13.09 0Z"
            fill={theme.tooltip.backgroundColor}
          />
        </svg>
      </span>
      <div css={messageClass} className={"ig-dp-tooltip-msg"}>
        <span>{text}</span>
      </div>
    </div>
  );
};
